
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'deleteAccount'
}

export const createSchema = (t: TFunction) => {
  return z.object({
    password: z.string().min(1, t('content.validation.passwordRequired', tConfig)),
    reason: z.string().min(1, t('content.validation.reasonRequired', tConfig)),
    deleteConfirmation: z.string()
  })
}

export type DeleteAccountFormData = z.infer<ReturnType<typeof createSchema>>
